"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatTileGrid = StatTileGrid;
var jsx_runtime_1 = require("react/jsx-runtime");
var stat_tile_1 = require("./stat-tile");
function StatTileGrid(props) {
    var tiles = props.tiles;
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4", children: tiles.map(function (tile) { return ((0, jsx_runtime_1.jsx)(stat_tile_1.StatTile, { tile: tile }, tile.label)); }) }));
}
